import { Pipe } from '@angular/core';

// Tell Angular2 we're creating a Pipe with TypeScript decorators
@Pipe({
    name: 'MemberPipe'
})
export class MemberPipe {

    // Transform is the new "return function(value, args)" in Angular 1.x
    transform(value, args?) {
        // ES6 array destructuring
        let val;
        let str;
        if (args) {
            args = args.toLowerCase();
            return value.filter(person => {
                for (let key in person) {
                    val = person[key];
                    if (val instanceof Array) {
                        for (let item of val) {
                            if (item['facilityName']) {
                                str = item['facilityName'].toString().toLowerCase();
                                if (str.indexOf(args) == 0) {
                                    return person;
                                }
                            }
                        }
                        for (let item of val) {
                            str = item.toString().toLowerCase();
                            if (str.indexOf(args) == 0) {
                                return person;
                            }
                        }
                    } else {
                        if (val) {
                            val = val.toString().toLowerCase();
                            if (val.indexOf(args) == 0) {
                                return person;
                            }
                        }
                    }

                }
            });
        }
        else {
            return value;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/search.member.ts